import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "./UnifiedFormStyles.css";
import AppButton from "../../Components/MerchantButton";
import { compressAndUpload } from "../../Helpers/Utils/photoUpload";

function DCCFlyerPhoto({ navigation, primaryDetails, setPrimaryDetails }) {
  const [isError, setIsError] = useState({
    dcc_photo: false,
  });

  const [isUploading, setIsUploading] = useState(false);

  const handlePhotoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 5 * 1024 * 1024) {
      toast.error("Photo exceeds 5MB limit. Please retake the photo.", {
        autoClose: 3000, hideProgressBar: true, theme: "colored"
      });
      e.target.value = '';
      return;
    }

    setIsUploading(true);
    try {
      const uploadResult = await compressAndUpload(file);
      if (!uploadResult.success) {
        toast.error(uploadResult.error || "Upload failed. Please try again.");
        e.target.value = '';
        return;
      }
      setPrimaryDetails(prev => ({
        ...prev,
        dcc_photo_temp_path: uploadResult.temp_path
      }));
      if (isError.dcc_photo) {
        setIsError(prev => ({ ...prev, dcc_photo: false }));
      }
    } catch (error) {
      toast.error("Error uploading photo");
    } finally {
      setIsUploading(false);
    }
  };

  const validateForm = () => {
    const errors = {};
    
    if (!primaryDetails.dcc_photo_temp_path) {
      errors.dcc_photo = true;
      toast.error("Please upload DCC flyer photo", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
    }

    setIsError(errors);
    return Object.keys(errors).length === 0;
  };

  const handleNext = () => {
    if (validateForm()) {
      // Navigate to next section
      navigation.go("maya-kita-club-flyer");
    }
  };

  const handleBack = () => {
    navigation.previous();
  };

  const handleViewFolder = () => {
    // Handle view folder functionality
    console.log("View folder clicked");
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">

          {/* Main Form */}
          <Col md={10}>
              <div className="form-main-header">
                <h4 className="form-title">
                  DCC FLYER PHOTO
                </h4>
                <p className="form-desc">
                  Section 91 of 110
                </p>
              </div>
              <div className="form-main">
              <div className="form-main-content">
                <Form className="form-form">

                  {/* File Upload Section */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      Upload DCC flyer photo <span className="form-required">*</span>
                      {primaryDetails.dcc_photo_temp_path && !isUploading && (
                        <span style={{ marginLeft: '10px', color: '#28a745' }}>✅ Uploaded</span>
                      )}
                    </Form.Label>
                    <Form.Control
                      type="file"
                      accept="image/*"
                      onChange={handlePhotoUpload}
                      isInvalid={isError.dcc_photo}
                      disabled={isUploading}
                    />
                    {isUploading && <div style={{ color: '#007bff', fontSize: '13px', marginTop: '6px' }}>⏳ Uploading...</div>}
                    {isError.dcc_photo && (
                      <div className="form-error">Required</div>
                    )}
                  </Form.Group>

                  {/* Navigation Buttons */}
                  <div className="form-btn-row">
                    <AppButton
                      onClick={handleBack}
                      variant="back"
                      className="form-btn variant-secondary"
                    >
                      ← Back
                    </AppButton>
                    <AppButton
                      onClick={handleNext}
                      variant="next"
                      className="form-btn variant-primary"
                    >
                     Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default DCCFlyerPhoto;
